import { ExclamationCircleOutlined } from "@ant-design/icons";
import { App, Form } from "antd";

import { AccountSelect } from "../../components/selects/account-select";
import { useMergeAccounts } from "../../data/use-accounts";
import { useOnChange } from "../../hooks/use-on-change";
import { Modal } from "components/modal";

export const MergeAccountsModal = (props) => {
  const { close, isOpen } = props;

  const { modal } = App.useApp();

  const mergeAccounts = useMergeAccounts({
    onSuccess: close,
  });

  const [form] = Form.useForm();

  useOnChange(
    isOpen,
    () => {
      if (!isOpen) {
        return;
      }

      form.setFieldsValue({
        childIds: [],
        parentId: null,
      });
    },
    [isOpen, form]
  );

  return (
    <Modal
      confirmLoading={mergeAccounts.isLoading}
      okText="Merge"
      onCancel={close}
      onOk={form.submit}
      title="Merge Accounts"
      open={isOpen}
    >
      <Form
        form={form}
        labelCol={{ span: 6 }}
        wrapperCol={{ span: 18 }}
        onFinish={(values) => {
          modal.confirm({
            title: "Are you sure you want to merge these accounts?",
            icon: <ExclamationCircleOutlined />,
            content: "This cannot be undone!",
            okText: "Yes",
            okType: "danger",
            cancelText: "No",
            onOk: () => mergeAccounts.mutate(values),
          });
        }}
      >
        <div style={{ marginBottom: "16px" }}>
          The secondary account relationships will be reassigned to the primary
          account. The secondary accounts will then be archived.
        </div>
        <div style={{ marginBottom: "16px" }}>
          <strong>
            If you wish to retain any fields, please update them prior to
            merging.
          </strong>
        </div>
        <AccountSelect
          label="Primary"
          name="parentId"
          rules={[{ required: true }]}
        />
        <AccountSelect
          label="Secondary"
          mode="multiple"
          name="childIds"
          rules={[{ required: true }]}
        />
      </Form>
    </Modal>
  );
};
